import type {
  Character,
  Command,
  StatusBoard,
  World,
} from '@/features/studio-renew/types'

export type MaterialKind = 'world' | 'character' | 'status' | 'command'
type Materials = {
  world: World
  character: Character
  status: StatusBoard
  command: Command
}
const EMPTY: { [K in MaterialKind]: Omit<Materials[K], 'id' | 'updatedAt'> } = {
  world: {
    name: '',
    summary: '',
    cover: '',
    body: '',
    keywords: [],
    places: [],
    visibility: 'private',
  },
  character: {
    worldMode: 'none',
    worldId: null,
    worldNote: '',
    image: '',
    name: '',
    tagline: '',
    persona: '',
    forbidden: [],
    habits: [],
    album: [],
  },
  status: { name: '', fields: [], html: '' },
  command: { key: '', title: '', description: '', html: '' },
}

export function emptyMaterial<K extends MaterialKind>(
  kind: K
): Omit<Materials[K], 'id' | 'updatedAt'> {
  return structuredClone(EMPTY[kind])
}

/** 로컬 작성 의도이며 서버 리소스 URL이나 참조로 보내지 않는다. */
export const isMaterialDraftId = (id: string) =>
  /^draft-[0-9a-f-]{36}$/.test(id)

const mappingKey = (owner: string, kind: MaterialKind, id: string) =>
  `veluvit:studio-material-id:${encodeURIComponent(owner)}:${kind}:${id}`

/** 내용은 저장하지 않는다. 새로고침 뒤에는 서버 소유 목록으로 확인한 ID만 다시 연결한다. */
export function rememberMaterialDraftId(
  owner: string,
  kind: MaterialKind,
  localId: string,
  serverId: string
) {
  try {
    sessionStorage.setItem(mappingKey(owner, kind, localId), serverId)
  } catch {
    /* 저장된 서버 자료에는 영향이 없다. */
  }
}

export function readMaterialDraftId(
  owner: string,
  kind: MaterialKind,
  localId: string
): string | null {
  try {
    return sessionStorage.getItem(mappingKey(owner, kind, localId))
  } catch {
    return null
  }
}
